import { ProductsListItem } from "modules/products";
import { VariantSummary } from "modules/products/apis/useGetVariantsByIds/getVariantsByIds.request";

import { VariantPreview } from "../whatsappAdProducts.types";

export const productsListItemToPreview = (
  item: ProductsListItem
): VariantPreview => ({
  id: item.id,
  productId: item.productId,
  categoryId: item.categoryId,
  name: item.name,
  image: item.image,
  categoryName: item.categoryName,
  colorValue: item.colorAttributeValue?.value
});

export const variantSummaryToPreview = (
  summary: VariantSummary
): VariantPreview => ({
  id: summary.id,
  productId: summary.productId,
  categoryId: summary.product?.categoryId,
  name: summary.name,
  image: summary.preview ?? summary.compressedPreview ?? null
});
